import { FC, lazy, Suspense } from "react";
import { GroupedSetModel } from "../../Admin/pages/Mobile/EditMaskStructure/EditMaskStructure";

const SetMasks = lazy(() => import("./SetMasks"));

interface SetMasksProps {
    setModel: GroupedSetModel;
    removeSet: (set: GroupedSetModel) => void;
}

const SetMasksComponent: FC<SetMasksProps> = ({ setModel, removeSet }) => {
    return (
        <Suspense fallback={<div>Loading...</div>}>
            <SetMasks
                setModel={setModel}
                removeSet={removeSet} />
        </Suspense>
    );
}

export default SetMasksComponent;